// extracted by mini-css-extract-plugin
export default {"flexContainer":"MaskTabs_flexContainer__4hcZE"};